import React from "react";
import "../styles/Certifications.css"; // Import CSS file

const Certifications = () => {
  return (
    <section id="certifications" className="certifications-section">
      <div className="certifications-overlay">
        <div className="certifications-main">
          <div className="certifications-content">
            <h2 className="certifications-title">CERTIFICATIONS</h2>
            <p className="certifications-description">
              Bhanot’s operations have earned quality, environmental, and safety certifications.
            </p>
          </div>
        </div>
      </div>
      <div className="certifications-details">
        <div className="policy text-justify text-center">
          <h3>QUALITY POLICY</h3>
          <p>We earn customer trust by delivering high-quality products.</p>
        </div>
        <div className="policy text-justify text-center">
          <h3>ENVIRONMENTAL & SAFETY POLICY</h3>
          <p>We commit to environmental safety and responsible business practices.</p>
        </div>
      </div>
    </section>
  );
};

export default Certifications;